// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"d69caa4f","247":"d2af5f6c","453":"6517b5f8","627":"30fcd06b","653":"cf9db717","834":"79717a8e","867":"42362ceb","923":"f39ddb39","938":"cf89967b"}[chunkId] + ".chunk.js";
};